<template>
  <div :class="name">
    <div v-if="$router.currentRoute.name === 'passengers-passenger'">
      <h1 class="text-xs-center">Passenger Details</h1>
      <br />
      <v-form v-if="currentPassenger && !currentPassengerError" @submit.prevent="update()" ref="form">
        <div class="layout justify-space-between mb-2">
          <div>
            <v-btn small :disabled="apiInProgress || !currentPassenger.passengerIdentifier || !currentPassenger.passengerIdentifier.phoneNumber" :to="{ name: 'passenger-transactions', query: { searchPhone: currentPassenger.passengerIdentifier.phoneNumber } }"><v-icon left small>fal fa-money-check-alt</v-icon> Transactions</v-btn>
            <v-btn @click="registerAlternateIdentifier()" small :disabled="apiInProgress || isNonValidPassenger() || isOnlyInvestor"><v-icon small>fal fa-signal-stream</v-icon> &nbsp; Register Beacon/Tag</v-btn>
            <v-btn small :disabled="apiInProgress || isNonValidPassenger() || isOnlyInvestor" :to="{ name: 'promotions-adhocpromotion', query: { phone: currentPassenger.passengerIdentifier.phoneNumber } }"><v-icon left small>fal fa-hand-holding-usd</v-icon> Send Promotional Credit</v-btn>
          </div>
          <div>
            <v-btn color="warning mr-2" flat @click.stop="loadParentView" :disabled="apiInProgress">Back to list</v-btn>
<!--            <v-btn color="primary" type="submit" v-if="hasUserType('admin')" :disabled="apiInProgress || !isDataEdited()" :loading="apiInProgress">Save</v-btn>-->
          </div>
        </div>
        <v-alert v-show="currentPassenger.dateArchived">
          <h3 class="text-xs-center">This passenger is archived</h3>
        </v-alert>
        <v-alert
          v-if="phoneBlacklistRecord"
          :type="phoneBlacklistAlertType"
          class="mb-3"
          value="true"
        >
          <div class="layout justify-space-between align-center">
            <div>
              <strong>Blacklisted phone detected</strong>
              <div>
                Threat level: <strong>{{ phoneBlacklistThreatLabel }}</strong>
              </div>
              <div v-if="Number(phoneBlacklistRecord.threatLevel) >= 2">
                This phone number is high risk and passenger logins/registrations are blocked.
              </div>
              <div v-else>
                This phone number is suspicious. Refunds are restricted unless "permitted until" date is set.
                <span v-if="isRefundPermitted">Refunds currently permitted.</span>
                <span v-else>Refunds currently restricted.</span>
              </div>
            </div>
            <div>
              <v-btn
                small
                color="primary"
                :to="{ name: 'passengers-phone-blacklist-phone', params: { phoneBlacklistId: phoneBlacklistRecord.id } }"
              >
                View blacklist record
              </v-btn>
            </div>
          </div>
        </v-alert>
        <v-alert type="info" v-show="currentPassenger.activationCode && currentPassenger.activationCodeExpiryLabel">
          <h3 class="text-xs-center">This passenger is pending activation</h3>
        </v-alert>
        <v-alert type="info" v-show="currentPassenger.transferCode && currentPassenger.transferCodeExpiryLabel">
          <h3 class="text-xs-center">This passenger is pending a transfer</h3>
        </v-alert>
        <v-layout row wrap>
          <v-flex sm5 pa-2>
            <v-layout row align-center>
              <v-flex sm5 pa-2 class="text-xs-right">
                <span v-if="!currentPassenger.dateArchivedLabel"><strong>Not archived</strong></span>
                <span v-if="currentPassenger.dateArchivedLabel"><strong>Archived: {{currentPassenger.dateArchivedLabel}}</strong></span>
              </v-flex>
              <v-flex sm7 pa-2>
                <v-btn @click="archivePassenger(currentPassenger)" small class="warning darken-1" v-show="!isNonValidPassenger()" :disabled="apiInProgress || isOnlyInvestor"><v-icon left small>fal fa-archive</v-icon> Archive</v-btn>
                <v-btn @click="loadUnarchiveDialog(currentPassenger)" small class="warning darken-1" v-show="isNonValidPassenger()" :disabled="apiInProgress || isOnlyInvestor"><v-icon left small>fal fa-undo</v-icon> Unarchive</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row align-center v-if="!isNonValidPassenger() && hasAdminPermissions">
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Manage password</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                <v-btn small @click="sendNewPassword(currentPassenger)" :disabled="apiInProgress || isOnlyInvestor"><v-icon left small>fal fa-key</v-icon> Send New Password</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row align-center v-if="currentPassenger && !isNonValidPassenger() && hasAdminPermissions">
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Re-registration restrictions</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                <span v-if="!currentPassenger.passengerIdentifier.dateReRegistrationGuarded">Re-registration Allowed</span>
                <v-btn v-if="currentPassenger.passengerIdentifier.dateReRegistrationGuarded" small @click="clearReRegistrationGuard(currentPassenger)" :disabled="apiInProgress || isOnlyInvestor">Allow Re-registration</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Last updated</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{currentPassenger.dateUpdatedLabel || 'N/A'}}
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Date created</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{currentPassenger.dateCreatedLabel}}
              </v-flex>
            </v-layout>
            <v-layout row align-center v-if="currentPassenger.activationCodeExpiryLabel">
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Activation code expiry</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{currentPassenger.activationCodeExpiryLabel}}
              </v-flex>
            </v-layout>
            <v-layout row align-center v-if="currentPassenger.transferCodeExpiryLabel">
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Transfer code expiry</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{currentPassenger.transferCodeExpiryLabel}}
              </v-flex>
            </v-layout>
            <v-layout row align-top>
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Recovery contact</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{currentPassenger.stUser && currentPassenger.stUser.metadata && currentPassenger.stUser.metadata.recoveryContact ? currentPassenger.stUser.metadata.recoveryContact : 'N/A'}}
                <div v-if="currentPassenger && !isNonValidPassenger() && hasAdminPermissions">
                  <v-btn small @click="loadRecoveryContactDialog()">Update Recovery Contact</v-btn>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row align-top>
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Refund restrictions (from blacklisted phones or agent staff top ups)</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{currentPassenger && currentPassenger.agentStaffTopUpDeductionsExpiryLabel ? `Permitted until ${currentPassenger.agentStaffTopUpDeductionsExpiryLabel}` : 'Restricted'}}
                <div v-if="currentPassenger && !isNonValidPassenger() && hasAdminPermissions">
                  <v-btn small @click="loadAgentStaffRefundDialog()">Set Permitted Until Date</v-btn>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row align-top v-if="currentPassenger && !isNonValidPassenger() && hasAdminPermissions">
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Confirmation code(s)</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                <div>Refresh: <v-btn fab small :disabled="apiInProgress" @click="refreshConfirmationCodes()"><v-icon>far fa-sync-alt</v-icon></v-btn></div>
                <div v-if="displayConfirmationCodes">
                  <ul v-if="currentPassenger.passengerIdentifiers && currentPassenger.passengerIdentifiers.length">
                    <li v-if="currentPassenger.passengerIdentifiers[0].activationCode">
                      <span>{{currentPassenger.stUser.metadata && currentPassenger.stUser.metadata.recoveryContact ? 'Recovery contact confirmation' : 'Activation code'}}</span>
                       <code>{{currentPassenger.passengerIdentifiers[0].activationCode}}</code>
                       <small v-if="currentPassenger.activationCodeExpiryLabel">
                         Expires {{currentPassenger.activationCodeExpiryLabel}}
                       </small>
                    </li>
                    <li v-if="currentPassenger.passengerIdentifiers[0].transferCode">
                      <span>Transfer code <small>(used for agent app confirmations or passenger phone transfers)</small></span>
                       <code>{{currentPassenger.passengerIdentifiers[0].transferCode}}</code>
                       <small v-if="currentPassenger.transferCodeExpiryLabel">
                         Expires {{currentPassenger.transferCodeExpiryLabel}}
                       </small>
                    </li>
                  </ul>
                  <div v-if="!currentPassenger.passengerIdentifiers || !currentPassenger.passengerIdentifiers.length">N/A</div>
                </div>
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Country detected</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{currentPassenger.currentCountryIdDetectedLabel}}
              </v-flex>
            </v-layout>
            <v-layout row align-center>
              <v-flex sm5 pa-2 class="text-xs-right">
                <strong>Country set</strong>
              </v-flex>
              <v-flex sm7 pa-2>
                {{currentPassenger.currentCountryIdSetLabel}}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm7 pa-2 class="info-column">
            <v-layout row wrap>
              <v-flex xs12 pa-1>
                <div class="info-card">
                  <div class="info-card__head">
                    <v-icon class="info-card__icon">{{registrationOriginIcon}}</v-icon>
                    <span class="info-card__label">Registered via</span>
                    <span class="info-card__value" v-if="registrationOrigin">{{registrationOriginLabel}}</span>
                    <span class="info-card__placeholder" v-else>Not checked yet</span>
                    <v-btn
                      class="info-card__action"
                      icon
                      small
                      :loading="loadingRegistrationOrigin"
                      :disabled="apiInProgress || loadingRegistrationOrigin"
                      @click="loadRegistrationOrigin()">
                      <v-icon small>far fa-search</v-icon>
                    </v-btn>
                  </div>
                  <div
                    class="info-card__meta info-card__meta--inline"
                    v-if="registrationOriginAgentName || registrationOriginDateLabel || (registrationOrigin && registrationOrigin.identifierType)">
                    <span v-if="registrationOriginAgentName">
                      Agent:
                      <router-link
                        v-if="registrationOrigin.agent.agentProfileId"
                        :to="{ name: 'agents-agent', params: { agentId: registrationOrigin.agent.agentProfileId } }">{{registrationOriginAgentName}}</router-link>
                      <span v-else>{{registrationOriginAgentName}}</span>
                    </span>
                    <span v-if="registrationOriginDateLabel">Registered: {{registrationOriginDateLabel}}</span>
                    <span v-if="registrationOrigin && registrationOrigin.identifierType">Identifier type: {{registrationOrigin.identifierType}}</span>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 pa-1>
                <div class="info-card">
                  <div class="info-card__head">
                    <v-icon class="info-card__icon">far fa-mobile-alt</v-icon>
                    <span class="info-card__label">Phone number</span>
                    <span class="info-card__value">{{currentPassenger.passengerIdentifier ? currentPassenger.passengerIdentifier.phoneNumber : 'N/A'}}</span>
                    <span class="info-card__badge" v-if="primaryMoneyAccountTypeLabel">
                      <img v-if="primaryMoneyAccountTypeLogo" :src="primaryMoneyAccountTypeLogo" alt="Money account type logo" class="info-card__logo" />
                      {{ primaryMoneyAccountTypeLabel }}
                    </span>
                    <span class="info-card__flag" v-if="currentPassenger.passengerIdentifier">
                      <v-icon class="success--text" small v-show="currentPassenger.passengerIdentifier.verified">far fa-check</v-icon>
                      <v-icon class="error--text" small v-show="!currentPassenger.passengerIdentifier.verified">far fa-times</v-icon> Verified
                    </span>
                  </div>
                  <div v-if="currentPassenger.passengerIdentifier">
                    <div class="info-card__meta info-card__meta--inline">
                      <span>Updated: {{currentPassenger.passengerIdentifier.dateUpdatedLabel}}</span>
                      <span>Created: {{currentPassenger.passengerIdentifier.dateCreatedLabel}}</span>
                    </div>
                    <div class="info-card__meta">Last access type: {{currentPassenger.lastAccessType}}</div>
                  </div>
                  <div v-if="extraMobileMoneyAccounts.length">
                    <v-btn class="info-card__toggle" flat small @click="extrasExpanded = !extrasExpanded">
                      <v-icon small class="mr-1">{{ extrasExpanded ? 'far fa-chevron-up' : 'far fa-chevron-down' }}</v-icon>
                      Other mobile money numbers ({{ extraMobileMoneyAccounts.length }})
                    </v-btn>
                    <div class="info-card__meta" v-show="extrasExpanded">
                      <div v-for="(extraAccount, index) in extraMobileMoneyAccounts" :key="`${extraAccount.phoneNumber}-${index}`">
                        <span>{{ extraAccount.phoneNumber }}</span>
                        <img v-if="extraAccount.typeLogoSrc" :src="extraAccount.typeLogoSrc" alt="Money account type logo" class="info-card__logo ml-1" />
                        <span class="ml-1">{{ extraAccount.typeLabel }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="currentPassenger.passengerIdentifier">
                    <div class="info-card__sublabel">Device details</div>
                    <div class="info-card__code">
                      <pre>{{currentPassenger.passengerIdentifier.osVersionLabel}}</pre>
                    </div>
                  </div>
                  <div v-if="hasAdminPermissions && (currentPassenger.passengerIdentifier || (currentPassenger.stUser.metadata && currentPassenger.stUser.metadata.mobileMoneyProfile))">
                    <div class="info-card__sublabel">
                      Mobile money profile
                      <v-btn class="info-card__action" icon small :disabled="apiInProgress" @click="refreshMobileMoneyProfile()"><v-icon small>far fa-sync-alt</v-icon></v-btn>
                    </div>
                    <div class="info-card__code" v-if="currentPassenger.stUser.metadata && currentPassenger.stUser.metadata.mobileMoneyProfile">
                      <pre>{{currentPassenger.stUser.metadata.mobileMoneyProfile}}</pre>
                    </div>
                    <div class="info-card__sublabel">
                      Refundable amounts
                      <v-btn class="info-card__action" icon small :loading="loadingRefundableBreakdown" :disabled="apiInProgress || loadingRefundableBreakdown" @click="loadRefundableBreakdown()">
                        <v-icon small>far fa-coins</v-icon>
                      </v-btn>
                    </div>
                    <div class="info-card__code info-card__code--tall" v-if="refundableBreakdown">
                      <div v-if="refundableBreakdown.perPhone && refundableBreakdown.perPhone.length">
                        <div class="info-card__meta" v-for="(phoneRefund, index) in refundableBreakdown.perPhone" :key="`${phoneRefund.phoneNumber}-${index}`">
                          {{phoneRefund.phoneNumber}}: <strong>{{formatRefundableAmount(phoneRefund.refundable)}}</strong>
                        </div>
                      </div>
                      <div class="info-card__meta" v-else>No mobile money numbers found for this passenger.</div>
                      <div class="info-card__meta">
                        Agent top-ups refundable:
                        <strong>{{formatRefundableAmount(refundableBreakdown.agentStaffTopUpRefundable)}}</strong>
                        <small v-if="!refundableBreakdown.permitAgentStaffTopUpRefund">(requires agent-staff refund expiry to be set)</small>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 md6 pa-1>
                <div class="info-card">
                  <div class="info-card__head">
                    <v-icon class="info-card__icon">far fa-wallet</v-icon>
                    <span class="info-card__label">Balance</span>
                    <span :class="'info-card__value' + (currentPassenger.balance > 0 ? ' success--text' : (currentPassenger.balance < 0 ? ' error--text' : ''))">{{currentPassenger.balanceLabel}}</span>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 md6 pa-1>
                <div class="info-card">
                  <div class="info-card__head">
                    <v-icon class="info-card__icon">far fa-ticket-alt</v-icon>
                    <span class="info-card__label">Last known trip</span>
                    <span class="info-card__text">{{currentPassenger.lastKnownTripLabel || 'N/A'}}</span>
                  </div>
                  <div
                    class="info-card__meta info-card__meta--inline"
                    v-if="currentPassenger.passengerTrip || (currentPassenger.passengerIdentifier && currentPassenger.passengerIdentifier.phoneNumber)">
                    <span v-if="currentPassenger.passengerTrip">{{currentPassenger.passengerTrip.dateUpdatedLabel}}</span>
                    <span v-if="currentPassenger.passengerIdentifier && currentPassenger.passengerIdentifier.phoneNumber">
                      <router-link :to="{ name: 'passenger-transactions', query: { searchPhone: currentPassenger.passengerIdentifier.phoneNumber, selectedLogTypes: 'purchased_ticket' } }">View more trips</router-link>
                    </span>
                  </div>
                </div>
              </v-flex>
              <v-flex xs12 pa-1>
                <div class="info-card">
                  <div class="info-card__head">
                    <v-icon class="info-card__icon">far fa-signal-stream</v-icon>
                    <span class="info-card__label">Last used beacon/tag</span>
                    <code v-if="currentPassenger.passengerAlternateIdentifier">{{currentPassenger.passengerAlternateIdentifier.identifierKey}}</code>
                    <span class="info-card__placeholder" v-else>N/A</span>
                    <battery-level-indicator
                      show-label
                      :metadata="currentPassenger.passengerAlternateIdentifier && currentPassenger.passengerAlternateIdentifier.metadata" />
                    <v-spacer />
                    <router-link class="info-card__link" :to="{ name: 'passengers-passenger-alternate-identifiers' }">Add/View identifiers</router-link>
                  </div>
                  <div class="info-card__meta info-card__meta--inline" v-if="currentPassenger.passengerAlternateIdentifier">
                    <span v-if="currentPassenger.passengerAlternateIdentifier.dateArchivedLabel">Archived: {{currentPassenger.passengerAlternateIdentifier.dateArchivedLabel}}</span>
                    <span>Updated: {{currentPassenger.passengerAlternateIdentifier.dateUpdatedLabel}}</span>
                    <span>Created: {{currentPassenger.passengerAlternateIdentifier.dateCreatedLabel}}</span>
                  </div>
                  <div class="info-card__meta info-card__meta--row">
                    <span>Beacon registration eligibility:</span>
                    <v-btn class="info-card__action" icon small :loading="loadingBeaconEligibility" :disabled="apiInProgress || loadingBeaconEligibility" @click="loadBeaconEligibility()">
                      <v-icon small>far fa-signal-stream</v-icon>
                    </v-btn>
                    <strong
                      v-if="beaconEligibility"
                      :class="beaconEligibility.eligible ? 'success--text' : 'warning--text'"
                    >{{beaconEligibility.eligible ? 'Eligible' : 'Not eligible'}}</strong>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="layout justify-end">
          <v-btn color="warning mr-2" flat @click.stop="loadParentView" :disabled="apiInProgress">Back to list</v-btn>
        </div>
      </v-form>
      <v-dialog
        transition="dialog-bottom-transition"
        scrollable
        persistent
        max-width="500"
        v-model="agentStaffRefundDialogLoaded">
        <v-card>
          <v-card-title class="headline grey lighten-2 text-xs-center" primary-title>
            Refund Restrictions
          </v-card-title>
          <v-form>
            <v-card-text>
              <div><strong>Allow refunds until this date</strong></div>
              <div style="max-width: 300px" v-if="!agentStaffRefundExpiryDisabled">
                <st-date-field
                  v-model="agentStaffRefundExpiry"
                  label="Select date"
                  :min="computedAgentStaffRefundExpiryMin"
                />
              </div>
              <div class="mt-3">
                <v-switch v-model="agentStaffRefundExpiryDisabled" label="Remove all permissions" />
              </div>
            </v-card-text>
          </v-form>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn color="warning" flat :disabled="savingRecoveryContact" @click="cancelAgentStaffRefundDialog()">
              Cancel
            </v-btn> &nbsp;
            <v-btn
              color="primary"
              :disabled="savingAgentStaffRefundExpiry"
              :loading="savingAgentStaffRefundExpiry"
              @click="saveAgentStaffRefundExpiry()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        transition="dialog-bottom-transition"
        scrollable
        persistent
        max-width="500"
        v-model="recoveryContactDialogLoaded">
        <v-card>
          <v-card-title class="headline grey lighten-2 text-xs-center" primary-title>
            Add/Update Recovery Contact
          </v-card-title>
          <v-form>
            <v-card-text>
              <v-layout justify-center class="mb-2">
                <v-btn-toggle v-model="recoveryContactType">
                  <v-btn small flat value="mobile">
                    <span>Mobile phone</span>
                  </v-btn>
                  <v-btn small flat value="email">
                    <span>Email</span>
                  </v-btn>
                </v-btn-toggle>
              </v-layout>
              <v-text-field v-show="recoveryContactType === 'email'" v-model="recoveryContactEmail" :rules="emailRules" validate-on-blur prepend-icon="fal fa-user" name="email" label="Email address" type="email"></v-text-field>
              <div v-show="recoveryContactType === 'mobile'"><phone-number-field v-model="recoveryContactPhone" :child-props="{ label: 'Mobile number' }" /></div>
            </v-card-text>
          </v-form>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn color="warning" flat :disabled="savingRecoveryContact" @click="cancelRecoveryContactDialog()">
              Cancel
            </v-btn> &nbsp;
            <v-btn color="primary"
               :disabled="savingRecoveryContact"
               :loading="savingRecoveryContact"
               @click="saveRecoveryContact()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          transition="dialog-bottom-transition"
          scrollable
          persistent
          max-width="500"
          v-model="unarchiveDialogLoaded">
        <v-card>
          <v-card-title class="headline grey lighten-2 text-xs-center" primary-title>
            Unarchive passenger
          </v-card-title>
          <v-form>
            <v-card-text>
              <h3>Please select deleted phone number to recover</h3>
              <v-select
                  pb-2
                  :disabled="isLoadingUnarchivePassengerIdentifiers"
                  :items="unarchivePassengerIdentifiers"
                  v-model="selectedUnarchivePassengerIdentifier"
                  label="Passenger number to recover"
              />
            </v-card-text>
          </v-form>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn color="warning" flat :disabled="isLoadingUnarchivePassengerIdentifiers" @click="unarchiveDialogLoaded = false">
              Cancel
            </v-btn> &nbsp;
            <v-btn color="primary"
                   :disabled="isLoadingUnarchivePassengerIdentifiers || !selectedUnarchivePassengerIdentifier"
                   :loading="isLoadingUnarchivePassengerIdentifiers"
                   @click="undoArchivePassenger(unarchiveDialogPassenger, selectedUnarchivePassengerIdentifier)">
              Unarchive
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-alert :value="currentPassengerError" type="error">
        <p>{{currentPassengerError}}</p>
        <p><a href @click.stop="refreshView()">Retry</a> or <router-link :to="{ name: 'passengers' }">Return to passengers list</router-link></p>
      </v-alert>
    </div>
    <router-view
      v-if="currentPassenger"
      :force-root-view-refresh="forceRootViewRefresh"
      :current-passenger="currentPassenger"
      :signed-in-user="signedInUser"
      :alternate-identifier-types="alternateIdentifierTypes"
      :has-user-type="hasUserType">
    </router-view>
  </div>
</template>

<style scoped>
/* Vuetify's .flex.sm7 caps the column at 58.33%; this narrows that cap on wide screens
   so the cards stop stretching past a comfortable reading width. */
.passengers-passenger .info-column {
  max-width: 600px;
}

.info-card {
  height: 100%;
  padding: 6px 10px 8px;
  border: 1px solid #e4e4e4;
  border-left: 3px solid #c9c9c9;
  border-radius: 3px;
  background-color: #fafafa;
}

.info-card__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 30px;
}

.info-card__head > * {
  margin-right: 8px;
}

.info-card__head .info-card__icon {
  font-size: 18px;
  color: #757575;
}

.info-card__label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #757575;
  white-space: nowrap;
}

.info-card__value {
  font-size: 17px;
  font-weight: 700;
  line-height: 1.25;
  word-break: break-word;
}

.info-card__text {
  font-size: 13px;
  line-height: 1.3;
}

.info-card__placeholder {
  font-size: 13px;
  color: #9e9e9e;
}

.info-card__badge {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  font-size: 11px;
  color: #616161;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}

.info-card__flag {
  font-size: 11px;
  color: #616161;
}

.info-card__logo {
  height: 14px;
  width: 14px;
  margin-right: 4px;
  object-fit: contain;
  vertical-align: middle;
}

.info-card__meta {
  font-size: 12px;
  line-height: 1.6;
  color: #616161;
}

.info-card__meta--inline,
.info-card__meta--row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.info-card__meta--inline > span + span::before {
  content: '\2022';
  margin: 0 6px;
  color: #c4c4c4;
}

.info-card__link {
  font-size: 12px;
}

.info-card__sublabel {
  display: flex;
  align-items: center;
  margin-top: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #8a8a8a;
}

.info-card__code {
  max-height: 74px;
  max-width: 520px;
  margin-top: 2px;
  padding: 3px 6px;
  overflow: auto;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 2px;
}

.info-card__code--tall {
  max-height: 110px;
}

.info-card__code pre {
  margin: 0;
  font-size: 11px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
}

.info-card .info-card__action {
  height: 26px;
  width: 26px;
  margin: 0 0 0 4px;
}

.info-card .info-card__toggle {
  height: 24px;
  margin: 2px 0 0;
  padding: 0 6px;
  font-size: 11px;
}
</style>

<script>
import src from './src'
export default src
</script>
